

<div class="snowflakeDcoContent">

  <!-- Checkbox to toggle filter -->
  <mat-checkbox [(ngModel)]="showImported" (change)="applyFilter()">
    Show only imported DCOs
  </mat-checkbox>

  <table mat-table [dataSource]="snowflakeDCOsDataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)" *ngIf="snowflakeDCOs.length > 0">
    <ng-container matColumnDef="imported">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Imported </th>
      <td mat-cell *matCellDef="let dco">
        <mat-checkbox [checked]="dco.savedDco" disabled></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Active </th>
      <td mat-cell *matCellDef="let dco">
        <mat-checkbox [checked]="dco.savedDco?.active" disabled></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Key / Identifier </th>
      <td mat-cell *matCellDef="let dco"> {{ dco.name }} </td>
    </ng-container>

    <ng-container matColumnDef="displayName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Display Name </th>
      <td mat-cell *matCellDef="let dco"> {{ dco.savedDco?.displayName }} </td>
    </ng-container>

    <ng-container matColumnDef="memberCount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Active Members </th>
      <td mat-cell *matCellDef="let dco"> {{ dco.activeMemberCount }} </td>
    </ng-container>

    <ng-container matColumnDef="ccos">
      <th mat-header-cell *matHeaderCellDef> CCOs </th>
      <td mat-cell *matCellDef="let dco">
        <p *ngFor="let cco of dco.snowflakeCcos">
          {{ cco.name }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="centered-column"> Actions </th>
      <td mat-cell *matCellDef="let dco" class="centered-column">
        <button mat-button (click)="openAddEditDCODialog(dco)">
          <span *ngIf="!dco.savedDco">
            Import
          </span>
          <span *ngIf="dco.savedDco">
            Edit
          </span>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="snowflakeDCOsDataColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: snowflakeDCOsDataColumns" class="table-row"></tr>
  </table>

  <div *ngIf="snowflakeDCOs.length === 0" class="no-data-message">
    No Snowflake DCO found.
  </div>
</div>
